export const productShortName = 'Industrial Boilers & Heat Exchangers — Professional Edition';
export const productBrand = 'Industrial Boilers & Heat Exchangers';
export const productEdition = 'Professional Edition';
export const productLabel = 'Industrial Boilers & Heat Exchangers · Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/4VNQSdiwdphGE66H4doa9E/MOCKUP_BOILERS.png';
export const productImageAlt =
  'Industrial Boilers & Heat Exchangers Professional Edition: six volumes covering heat and steam fundamentals, industrial boilers, water treatment and safety devices, steam distribution, heat exchangers and maintenance, plus five bonus resources';

export const checkoutUrl = 'https://industrial-boilers-heat-exchangers.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how heat and steam move through the plant',
  'No more uncertainty about boiler controls, water treatment and safety devices',
  'No more guessing with steam traps, condensate and water hammer',
  'No more exchangers losing performance without knowing why',
  'No more improvising inspection, cleaning and troubleshooting',
];
